import { buildClassNames } from "./classNames";

const cl = buildClassNames(
    x => x,
    (x, y) => x.concat(y)
);

export interface IBemElement {
    (name, ...mods): string;

    mods: (...mods) => string;
    prefixed: (name) => IBemElement;

    subBlock: (name) => [IBemBlock, IBemElement];
}

interface IBemBlock {
    (...mods): string;

    element: IBemElement;
}

export interface IBemPrefixedElementContainer {
    bl?: IBemBlock;
    el: IBemElement;
}

export function bemBlock(blockClassName: string): [IBemBlock, IBemElement] {
    const block = link.bind(null, blockClassName) as IBemBlock;
    block.element = bemElement(blockClassName + "__");
    return [block, block.element];
}

function bemElement(prefix: string): IBemElement {
    const el: IBemElement = (name, ...modifiers) =>
        link(prefix + name, ...modifiers);

    el.prefixed = name => bemPrefixedElement(prefix + name);

    el.mods = (...modifiers) => link(prefix, ...modifiers);

    el.subBlock = name => bemBlock(prefix.replace("__", `-${name}`));
    //link.bind(null, ) as IBemBlock;

    return el;
}

function bemPrefixedElement(prefix: string): IBemElement {
    const pel = bemElement(prefix + "-") as IBemElement;
    pel.mods = (...modifiers) => link(prefix, ...modifiers);
    return pel;
}

const link = (prefix: string, ...modifiers) => {
    const joins = cl(...modifiers);
    return (
        prefix +
        (joins.length < 1
            ? ""
            : " " + joins.map(x => prefix + "_" + x).join(" "))
    );
};
